import React from 'react'
import styled from 'styled-components'
import CartBanner from '../Components/Cart/CartBanner'
import Checkout from '../Components/Cart/Checkout';
import { useStateValue } from '../State/StateProvider';

const Cart = () => {
    const [{ basket, user }, dispatch] = useStateValue();
    return (
        <div>
            <CartBanner />
            <Checkout />
        </div>
    )
}

export default Cart

const CartItems = styled.div`
    text-align: center;
    background: #fff;
    min-height: 40vh;

`
